module.exports = __webpack_public_path__ + "joy-static/media/FlickIconDropShadow.54d4130b.png";